import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@opendate-app/setlist';

import useWidgetLogin from '../utils/useWidgetLogin';
import { admissionTicketCount } from '../utils/soldOutAddOns';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const useLogin = ({ confirm, ticketReservation, userContext, onAuthSuccess, rootUrl }) => (
  useWidgetLogin({
    confirmId: confirm.id,
    ticketReservationToken: ticketReservation?.token,
    userContext,
    onAuthSuccess,
    rootUrl
  })
);

export const LockedAddOnsIntro = (props) => {
  const { isLoggedIn, handleLoginClick } = useLogin(props);
  const ticketCount = admissionTicketCount(props.userContext);

  return (
    !isLoggedIn && props.lockedAddOns.length > 0 ? (
      <p className="mb-3" style={{ color: "var(--widget-secondary-text-color, #686868)" }}>
        Some add-ons require a ticket. <a href="#" onClick={handleLoginClick}>Sign in</a> to unlock them.
      </p>
    ) : isLoggedIn && ticketCount > 0 ? (
      <p className="mb-3" style={{ color: "var(--widget-secondary-text-color, #686868)" }}>
        You have {ticketCount} {ticketCount === 1 ? "ticket" : "tickets"} to this show.
      </p>
    ) : null
  );
};

const LockedAddOns = (props) => {
  const { isLoggedIn, handleLoginClick } = useLogin(props);

  return (
    <div>
      {props.lockedAddOns.map((addOn) =>
        <div className="card border-0"
             style={{ background: "#f9f9f9", marginBottom: "15px" }}
             key={addOn.id}>
          <div className="card-body d-flex align-items-center"
               style={{ paddingLeft: "15px", paddingRight: "15px", gap: "15px" }}>
            <div className="flex-grow-1" style={{ minWidth: 0 }}>
              <p className="mb-0" style={{ fontSize: "16px" }}>
                <strong>{addOn.name}</strong>
              </p>
              <p className="mb-0" style={{ fontSize: "16px" }}>
                {formatter.format(parseFloat(addOn.calculated_price))}
              </p>
              {addOn.description && addOn.description.length > 0 ? (
                <div className="mb-0 mt-2 small last-p-margin-0"
                     dangerouslySetInnerHTML={{ __html: addOn.simple_format_description }}
                     style={{ maxWidth: "400px" }}>
                </div>
              ) : null}
              <div className="small mt-1" style={{ color: "var(--widget-secondary-text-color, #686868)" }}>
                {addOn.require_add_on
                  ? `Requires ${(addOn.required_add_on_names || []).join(" or ") || "another add-on"}`
                  : "Requires a ticket to this show"}
              </div>
            </div>
            {isLoggedIn ? null : (
              <Button variant="secondary-color" onClick={handleLoginClick}>
                Sign in to add
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

LockedAddOnsIntro.propTypes = {
  confirm: PropTypes.object.isRequired,
  lockedAddOns: PropTypes.array.isRequired,
  ticketReservation: PropTypes.object,
  userContext: PropTypes.object,
  onAuthSuccess: PropTypes.func.isRequired,
  rootUrl: PropTypes.string.isRequired
};

LockedAddOns.propTypes = {
  confirm: PropTypes.object.isRequired,
  lockedAddOns: PropTypes.array.isRequired,
  ticketReservation: PropTypes.object,
  userContext: PropTypes.object,
  onAuthSuccess: PropTypes.func.isRequired,
  rootUrl: PropTypes.string.isRequired
};

export default LockedAddOns;
